var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { trigger: "click", width: "1200" },
      on: { show: _vm.onPopoverShow }
    },
    [
      _c(
        "span",
        {
          staticStyle: { cursor: "pointer" },
          attrs: { slot: "reference" },
          slot: "reference"
        },
        [_vm._v(_vm._s(_vm.taskId))]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "div",
            { staticStyle: { "padding-left": "20px", "column-count": "2" } },
            [
              _c("div", [
                _vm._v("spName: " + _vm._s(_vm.approvalDetail.spName))
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v("applyTime: " + _vm._s(_vm.approvalDetail.applyTime))
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v("templateId: " + _vm._s(_vm.approvalDetail.templateId))
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "applyerUserId: " + _vm._s(_vm.approvalDetail.applyerUserId)
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v("spStatus: " + _vm._s(_vm.approvalDetail.spStatus))
              ])
            ]
          ),
          _vm._v(" "),
          _c("TicketTaskForm", { attrs: { taskId: _vm.formTaskId } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c576744a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c576744a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/WorkWeixingetApprovalDialog.vue
// module id = 966
// module chunks = 75